<template>
  <div class="t-folder">
    <TIcon name="folder" size="64" />
    <input v-if="edit" class="t-folder-input" v-model="local_name" :ref="`tfolder_input_${folder.id}`" @change="finishRenaming()" @blur="exitEdit()"/>
    <TText v-else :text="folder.name" font_weight="300" size="11" align="center" />
    <TText v-if="parent" :text="parent.name" font_weight="300" size="9" align="center" />
  </div>
</template>
<script>
  import TIcon from '@/components/Taktify/TIcon.component.vue';
  export default {
    props: ['folder', 'prefix', 'parent'],
    components: {
      TIcon,
    },
    data: () => ({
      edit: false,
      local_name: '',
    }),
    created(){
      this.local_name = this.folder.name;
    },
    computed: {
    },
    methods: {
      startRenaming(){
        this.edit = true;
        this.$nextTick(() => {
          const input = this.$refs[`tfolder_input_${this.folder.id}`];
          this.$nextTick(() => {
            input.focus();
            input.select();
          });
        });
      },
      finishRenaming(){
        this.$emit('renameFolder', {
          id: this.folder.id,
          name: this.local_name,
        });
        this.exitEdit();
      },
      exitEdit(){
        this.edit = false;
      }
    }
  }
</script>
<style>
  .t-folder {
    height: 80px;
    width: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
  
  .t-folder-input {
    width: 90%;
    margin: 0px 4px;
  }

</style>
